import { IPublicClientApplication } from "@azure/msal-browser";
import { axiosGetRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/planosatividade";

function getActivityPlan(
    dataInicio: string,
    dataFim: string,
    matriculaAdp: string,
    msalInstance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        "data-inicio": dataInicio,
        "data-fim": dataFim,
        "matricula-adp": matriculaAdp,
    });

    return axiosGetRequest(
        `${route}/planos-atividade-docente${params}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

function getTeachingActivityPlan(
    teachingActivityPlanId: number,
    msalInstance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/${teachingActivityPlanId}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

function getInvalidActivityPlan(
    dataInicio: string,
    dataFim: string,
    matriculaAdp: string,
    msalInstance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        "data-inicio": dataInicio,
        "data-fim": dataFim,
        "matricula-adp": matriculaAdp,
    });

    return axiosGetRequest(
        `${route}/plano-atividade-invalido${params}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

function getHistoricTACH(
    tachId: number,
    msalInstance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/${tachId}/parecercoordenador`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

export default {
    getActivityPlan,
    getTeachingActivityPlan,
    getInvalidActivityPlan,
    getHistoricTACH,
};
